import { InbuiltRestClient } from './InbuiltRestClient';
var RestClient = /** @class */ (function () {
    function RestClient(externalImplementation, provider) {
        //Need to add logic to use customer implementation if it is provided
        if (externalImplementation) {
            this.restClientImplementation = externalImplementation;
        }
        else {
            this.restClientImplementation = InbuiltRestClient.getInstance(provider);
        }
    }
    RestClient.getInstance = function (externalImplementation, provider) {
        if (!this.restClient) {
            this.restClient = new RestClient(externalImplementation, provider);
        }
        return this.restClient;
    };
    RestClient.prototype.get = function (parameters) {
        return this.restClientImplementation.get(parameters);
    };
    RestClient.prototype.post = function (parameters) {
        return this.restClientImplementation.post(parameters);
    };
    RestClient.prototype.generic = function (parameters) {
        return this.restClientImplementation.generic(parameters);
    };
    return RestClient;
}());
export { RestClient };
//# sourceMappingURL=RestClient.js.map